import { Component, Input, ViewChild } from '@angular/core'
import { ModalContainerComponent } from '../../_common/modal-container/modal-container.component'
import { CoreService, NotificationService } from '../../../services'
import { User } from 'depoto-core/src/entities'
import { SchemaUtil } from '../../../utils'
import { TranslateService } from '@ngx-translate/core'

import * as Sentry from '@sentry/angular-ivy'

@Component({
  selector: 'app-modal-change-pass',
  templateUrl: './modal-change-pass.component.html',
})
export class ModalChangePassComponent {
  @ViewChild('modal') childModal: ModalContainerComponent
  @Input() userProfile: User
  user: User
  password = ''
  isValid: boolean = false
  loading = true

  constructor(
    private notificationService: NotificationService,
    private translateService: TranslateService,
    private core: CoreService,
  ) {}

  async setCurrentUser() {
    if (this.userProfile) {
      this.user = this.userProfile
      this.loading = false
      return
    }
    const userProfile = await this.core.services.user.getMyProfile(SchemaUtil.userProfile)
    if (userProfile) {
      this.user = new User(userProfile)
      this.core.services.storage.set(this.core.services.storage.keys.auth.company, this.user.company)
      this.core.services.user.setCurrentUser(this.user.email)
      this.loading = false
    }
  }

  async changePass() {
    if (this.isValid) {
      this.user.plainPassword = this.password
      await this.core.services.user
        .update(this.user)
        .then(res => {
          this.notificationService.success(this.translateService.instant('alert.password.changed'))
          this.hideChildModal()
        })
        .catch(err => console.log(err))
    } else {
      this.notificationService.warning(this.translateService.instant('modal-change-pass.invalid'))
    }
  }

  public async showChildModal() {
    await this.setCurrentUser()
    this.childModal.showChildModal()
  }

  public hideChildModal(): void {
    this.childModal.hideChildModal()
  }
}
